module.exports = __webpack_public_path__ + "media/images/icon_general_link-5bdaa7c852284d5bb3e3be787abac4dd.svg";